// extracted by mini-css-extract-plugin
export default {"section":"reviews_section__6ttIz","header":"reviews_header__V-PPe","title":"reviews_title__WNHc6","text":"reviews_text__rxy7c"};